import { useRouter } from 'next/router';
import { useMemo } from 'react';

/**
 * Receives a single locale or a list of locales and
 * returns true if the current locale is included in the list
 */
export const useHasCurrentLocale = (locales: string | string[]) => {
  const { locale } = useRouter();
  const isLocale = useMemo(() => {
    if (!locale) {
      return false;
    }
    if (Array.isArray(locales)) {
      return locales.includes(locale);
    }
    return locale === locales;
  }, [locale, locales]);
  return isLocale;
};
